import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  ${({ theme }) => css`
    width: 100%;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: ${theme.colors.lightest};
    box-shadow: ${theme.colors.shadows.header};
    overflow: hidden;
  `}
`

export const Header = styled(Box)`
  padding: 24px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TitleBox = styled(Box)`
  ${({ theme }) => css`
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    color: ${theme.colors.secondary};
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      width: 20px;
      height: 20px;
    }

    @media (max-width: ${theme.screenSizes.tablet}) {
      max-width: 90%;
    }
  `}
`

export const CloseIcon = styled(Box)`
  ${({ theme }) => css`
    svg {
      color: ${theme.colors.secondary};
      cursor: pointer;
    }
  `}
`

export const Content = styled(Box)`
  padding: 16px 24px 24px;
  border-radius: 0 0 10px 10px;
  overflow: auto;
`

export const Footer = styled(Box)`
  padding: 24px;
  display: flex;
  gap: 16px;
  box-shadow: 0 16px 16px 16px rgb(174, 174, 174);
`
